import React from 'react'
import classNames from 'classnames'
import { useDraggable } from '@dnd-kit/core'
import { CSS } from '@dnd-kit/utilities'
import Text from '@components/Text'

export const Draggable = ({index, children, draggingId, fromDroppableId, withMargin = true, wordIsCorrect = false, redBorder = false}) => {
    const {attributes, listeners, setNodeRef, transform} = useDraggable({
        id: 'draggable-' + index,
        disabled: wordIsCorrect,
        data: {
            fromDroppableId
        }
    })
    const style = {
        transform: CSS.Translate.toString(transform),
        touchAction: 'none',
        ...(() => (redBorder || wordIsCorrect) ? {
            position: 'absolute',
            width: 'calc(100% + 2px)',
            bottom: '-1px',
            top: '0px'
        } : {})()
    }
    const isDragging = draggingId === 'draggable-' + index
    const classes = classNames(
        'flex items-center justify-center border bg-white outline-none text-sm text-center font-medium leading-tight rounded-md px-2 py-1.5 mt-[-1px]',
        {
            'mr-4 mb-4': withMargin,
            'w-full': !withMargin,
            'z-50': isDragging,
            'z-0': !isDragging,
            'bg-lightGreen': wordIsCorrect,
            'border-lightGreen': wordIsCorrect,
            'border-alertRed': redBorder,
            'rounded-t-none': redBorder || wordIsCorrect,
        }
    )

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...listeners}
            {...attributes}
            className={classes}
        >
            <Text>{ children }</Text>
        </div>
    )
}
